<template>
  <div>
    <div class="container-fluid px-0">
      <Nav
        @show-contrast-view="toggleShowContrast"
        @show-regular-font-view="toggleRegularFontView"
        @show-middle-font-view="toggleMiddleFontView"
        @show-big-font-view="toggleBigFontView"
      />
      <div class="d-flex flex-column flex-lg-row">
        <div class="order-2 order-lg-1 col-lg-7 px-0 bg-bee">
          <Content />
        </div>
        <div class="order-1 order-lg-1 col-lg-5 px-0">
          <Form />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Content from "./Content.vue";
import Nav from "./Nav.vue";
import Form from "./Form.vue";

export default {
  name: "Page",
  data() {
    return {
      contrastView: false,
      fontRegularView: true,
      fontMiddleView: false,
      fontBigView: false,
      mainPage: true,
    };
  },
  components: {
    Content,
    Nav,
    Form,
  },
  methods: {
    toggleShowContrast: function() {
      this.contrastView = !this.contrastView;
    },
    toggleRegularFontView: function() {
      this.fontRegularView = !this.fontRegularView;
    },
    toggleMiddleFontView: function() {
      this.fontMiddleView = !this.fontMiddleView;
    },
    toggleBigFontView: function() {
      this.fontBigView = !this.fontBigView;
    },
  },
  watch: {
    contrastView: function() {
      const el = document.body;
      if (this.contrastView) {
        el.classList.add("body--contrast");
      } else {
        el.classList.remove("body--contrast");
      }
    },
    fontRegularView: function() {
      const el = document.getElementsByTagName("html")[0];
        el.classList.remove("body--middle-font");
        el.classList.remove("body--big-font");
    },
    fontMiddleView: function() {
      const el = document.getElementsByTagName("html")[0];
     
        el.classList.add("body--middle-font");
        el.classList.remove("body--big-font");
      
    },
    fontBigView: function() {
      const el = document.getElementsByTagName("html")[0];
      
        el.classList.remove("body--middle-font");
        el.classList.add("body--big-font");
      
    },
  },
};
</script>
